import { createSelector } from 'reselect';
import PredesPlannedTransportAnomaliesOriginSummaryColumns
  from '../../containers/PredesPlannedTransportAnomaliesOriginSummaryColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_PLANNED_TRANSPORT_ANOMALIES_ORIGIN_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PredesPlannedTransportAnomaliesOriginSummaryColumns);
